(function () {
  'use strict';

  var mobileMenuQuery = window.matchMedia('(max-width: 1024px)');
  var openClass = 'hammer-mobile-submenu-open';
  var megaMenuToggleSelector = '.halo-sidebar_menu .site-nav-mobile .menu-dropdown__wrapper .site-nav > .site-nav-list > .menu_mobile_link_2';
  var standardMenuToggleSelector = '.halo-sidebar_menu .site-nav-mobile .no-megamenu .menu-lv-2 > .site-nav-list-dropdown > .menu_mobile_link_2';
  var toggleSelector = megaMenuToggleSelector + ', ' + standardMenuToggleSelector;

  function directChildWithClass(parent, className) {
    if (!parent) {
      return null;
    }

    return Array.prototype.find.call(parent.children, function (child) {
      return child.classList.contains(className);
    }) || null;
  }

  function itemToggle(item) {
    var wrapper = directChildWithClass(item, 'site-nav-list') || directChildWithClass(item, 'site-nav-list-dropdown');
    return wrapper && directChildWithClass(wrapper, 'menu_mobile_link_2');
  }

  function closeItem(item) {
    item.classList.remove(openClass);
    var toggle = itemToggle(item);
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function closeAll(scope) {
    (scope || document).querySelectorAll('.' + openClass).forEach(closeItem);
  }

  document.addEventListener('click', function (event) {
    if (!mobileMenuQuery.matches) {
      return;
    }

    var toggle = event.target.closest(toggleSelector);

    if (toggle) {
      var list = toggle.parentElement;
      var item = list && list.parentElement;
      var submenu = directChildWithClass(list, 'site-nav-sub') || directChildWithClass(list, 'list-menu--disclosure-2');

      if (!item || !submenu) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var shouldOpen = !item.classList.contains(openClass);
      var menu = item.closest('.menu-dropdown__column') || item.closest('.menu-dropdown__wrapper') || item.parentElement;

      if (menu) {
        menu.querySelectorAll('.' + openClass).forEach(function (openItem) {
          if (openItem !== item) {
            closeItem(openItem);
          }
        });
      }

      item.classList.toggle(openClass, shouldOpen);
      toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      return;
    }

    if (event.target.closest('.halo-sidebar-close, .mobileMenu-toggle, .halo-sidebar_menu .menu-dropdown__wrapper > .nav-title-mobile')) {
      closeAll(document);
    }
  }, true);

  window.addEventListener('resize', function () {
    if (!mobileMenuQuery.matches) {
      closeAll(document);
    }
  });
})();
